import { render, staticRenderFns } from "./scanforgetonShape1.vue?vue&type=template&id=aba096e6&scoped=true"
import script from "./scanforgetonShape1.vue?vue&type=script&lang=ts"
export * from "./scanforgetonShape1.vue?vue&type=script&lang=ts"
import style0 from "./scanforgetonShape1.vue?vue&type=style&index=0&id=aba096e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba096e6",
  null
  
)

export default component.exports